<div class="header-container">
  <div class="logo-container">
    <a class="sidebar-toggle" (click)="toggleSidebar()">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    @if (systemImageStore.headerLogo()) {
      <img [src]="systemImageStore.headerLogo()" width="50" />
    } @else {
      <img src="./assets/images/logo.png" width="50" />
    }
  </div>
</div>
<div class="header-container">

  <!-- <nb-select [(ngModel)]="selectedTheme" (ngModelChange)="onThemeChange($event)">
        <nb-option *ngFor="let theme of themes" [value]="theme">
          {{ theme | titlecase }}
        </nb-option>
      </nb-select> -->


  <div></div>
  <nb-actions>
    <nb-action class="user-action">
      @let currentUser = user$ | async;
      @if (currentUser) {
      <nb-user [nbContextMenu]="userMenu" [name]="currentUser.firstName"
        [picture]="query.data() ? query.data().avatar : ''" />
      }
    </nb-action>
  </nb-actions>
</div>